import React from "react";

import styled from "styled-components/macro";

function Container({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

function Title({ children }) {
  return <TitleWrapper>{children}</TitleWrapper>;
}

const Wrapper = styled.div`
  background: linear-gradient(to bottom, #0ea3c9, 10%, #288ec3);
  color: #fff;
  border-radius: 9px;
  padding: 16px;
  max-width: 540px;
  margin-bottom: 20px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Icon = styled.i`
  font-size: 20px;
`;

const MarketingBlurb = { Container, Title, Icon };
export default MarketingBlurb;
